import CategoryBreadcrumbs from '@core/components/Category/CategoryBreadcrumbs'
import SecondaryBar from '@core/components/header/SecondaryBar'
import { useProductDetailContext } from '@core/utils/models/product/ProductContext'

const ProductDetailCategoryBreadcrumbs: React.FC = () => {
  const { product } = useProductDetailContext() || {}

  if (!product) {
    return null
  }

  return (
    <SecondaryBar
      leftPart={
        <CategoryBreadcrumbs
          breadcrumbs={product?.breadcrumbs.hierarchy}
          invert={true}
        />
      }
    />
  )
}

export default ProductDetailCategoryBreadcrumbs
